import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'ff-table-cell',
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.scss']
})
export class TableCellComponent implements OnInit {
  
  @ViewChild('cellTemplate') template: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }

}
